import { render, staticRenderFns } from "./xskTabs.vue?vue&type=template&id=51ecca60&scoped=true&"
import script from "./xskTabs.vue?vue&type=script&lang=js&"
export * from "./xskTabs.vue?vue&type=script&lang=js&"
import style0 from "./xskTabs.vue?vue&type=style&index=0&id=51ecca60&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ecca60",
  null
  
)

export default component.exports